import axiosInstance from '../axiosInterceptor/axiosInstance'

const deleteTeam = async (data) => {
  const { orgId, teamId } = data
  const url = `v1/orgs/${orgId}/teams/${teamId}`
  return axiosInstance.delete(url)
}

export default deleteTeam
